import { QP_PAGE_SIZE_VALUE_DEFAULT, QP_PAGE_SIZE_VALUE_MAX } from './queryParamConstants';
import { pageTypeConstants } from './pageTypeConstants';

export const MIN_THIN_PAGE_COUNT = 30;
export const SWIPER_TABLET_TILES_COUNT = 3.5;
export const MAX_AD_LIMIT = 4;
export const GRID_TYPE_MOBILE_SESSION_STORAGE_KEY = 'selectedSbGridType';
export const SB_MOBILE_ITEM_TILE_DATA_TAG = 'item-tile-wrapper';
export const PAGE_SIZE_OPTIONS = [
    { size: QP_PAGE_SIZE_VALUE_DEFAULT, adLimit: 2 },
    { size: QP_PAGE_SIZE_VALUE_MAX, adLimit: MAX_AD_LIMIT },
];

export const tileMobileGridTypes = {
    COMPLETE_PRODUCT_INFO: 'COMPLETE_PRODUCT_INFO',
    PRODUCT_PHOTO_ONLY: 'PRODUCT_PHOTO_ONLY',
};

export const NOT_SUPPORTED_AMP_PAGES = [
    pageTypeConstants.ROOM,
    pageTypeConstants.SEARCH,
    pageTypeConstants.DEALER,
];

export const FILTER_NAME_CREATOR = 'creator';
export const MIN_RELATED_PAGES = 2;
export const MAX_RELATED_PAGES = 12;

export const INITIAL_VISIBLE_RELATED_CREATORS = 3;
export const REVEAL_RELATED_CREATORS_COUNT_DESKTOP = 6;
export const REVEAL_RELATED_CREATORS_COUNT_MOBILE = 3;

export const LINKS_BLOCK_DATA_TN = 'links-block';
